import * as constants from '../../constants';
import { apiSlice } from '../../api/apiSlice';

export const correctiveActionsSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getAllCountries: builder.query({
            query: () => {
                return {
                    url: constants.ALL_COUNTRIES,
                };
            },
        }),
        getCaCategories: builder.query({
            query: () => {
                return {
                    url: constants.CA_CATEGORIES,
                };
            },

        }),
        getCaRoles: builder.query({
            query: () => {
                return {
                    url: constants.CA_SCORECARD_ROLES,
                };
            },
        }),
        getCaApprovalOptions: builder.query({
            query: () => {
                return {
                    url: constants.CA_APPROVALOPTIONS,
                };
            },
        }),
        getCaApproverRoles: builder.query({
            query: () => {
                return {
                    url: constants.CA_APPROVERROLES,
                };
            },
        }),

        getCaTemplate: builder.query({
            query: (arg: any) => {
                const { countryId, categoryId, scorecardRoleId } = arg;
                return {
                    url: constants.CA_TEMPLATE,
                    params: { countryId, categoryId, scorecardRoleId },
                };
            },
            providesTags: ['Corrective_action'],
        }),

        insertCreateActionTemplate: builder.mutation({
            query: (arg: any) => ({
                url: constants.CREATE_CA_TEMPLATE,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Corrective_action'],
        }),
        insertCaApprovalQueues: builder.mutation({
            query: (arg: any) => ({
                url: constants.CREATE_CA_APPROVAL_QUEUES,
                method: 'POST',
                body: arg,
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
            }),
            invalidatesTags: ['Corrective_action'],
        }),
        getCaHistory: builder.query({
            query: (arg: any) => {
                const { empNo, loggedEmpNum } = arg;
                return {
                    url: constants.CA_HISTORY,
                    params: { empNo, loggedEmpNum },
                };
            },
            providesTags: ['Corrective_action'],
        }),
        getCaApprovalQueuesByTemplateId: builder.query({
            query: (arg: any) => {
                const { templateId } = arg;
                return {
                    url: constants.CA_APPROVAL_QUEUES,
                    params: { templateId },
                };
            }
        }),
        getCaApprovalStatusHistory: builder.query({
            query: (arg: any) => {
                const { caId } = arg;
                return {
                    url: constants.CA_APPROVAL_STATUS_HISTORY,
                    params: { caId },
                };
            },
            providesTags: ['Corrective_action'],
        }),
        getCaRecords: builder.query({
            query: (arg: any) => {
                const params = new URLSearchParams();
                if(arg.empNumber !== ''  ) params.append('employeeNumber', arg.employeeNumber);
                params.append('countryId', arg.countryId);
                if (arg.CaCategoryIds && arg.CaCategoryIds.length > 0) arg.CaCategoryIds.forEach((id: any) => params.append('CaCategoryIds', id));
                if (arg.SubCategoryIds && arg.SubCategoryIds.length > 0) arg.SubCategoryIds.forEach((id: any) => params.append('SubCategoryIds', id));
                if (arg.MisConductIds && arg.MisConductIds.length > 0) arg.MisConductIds.forEach((id: any) => params.append('MisConductIds', id));
                if (arg.SiteIds && arg.SiteIds.length > 0) arg.SiteIds.forEach((id: any) => params.append('SiteIds', id));
                if (arg.parentClientIds && arg.parentClientIds.length > 0) arg.parentClientIds.forEach((id: any) => params.append('ParentClientIds', id));
                if (arg.programIds && arg.programIds.length > 0) arg.programIds.forEach((id: any) => params.append('ProgramIds', id));
                params.append('CreationStartDate', arg.CreationStartDate);
                params.append('CreationEndDate', arg.CreationEndDate);
                return `${constants.CA_RECORDS}?${params.toString()}`;
            },
            providesTags: ['Corrective_action'],
        }),
        getGlLocations: builder.query({
            query: (arg: any) => {
                const { countryId } = arg;
                return {
                    url: constants.GLLOCATIONS,
                    params: { countryId },
                };
            },
            providesTags: ['Corrective_action'],
        }),
        getParentClients: builder.query({
            query: () => {
                return {
                    url: constants.CA_PARENT_CLIENT,
                };
            },
            providesTags: ['Corrective_action'],
        }),
        getPrograms: builder.query({
            query: (arg:any) => {
                const params = new URLSearchParams();
                if(arg.parentClientId && arg.parentClientId.length > 0 ){arg.parentClientId.forEach((id: any) => params.append('parentClientId', id));}
                return `${constants.CA_PROGRAMS}?${params.toString()}`;
            },
            providesTags: ['Corrective_action'],
        }),
        getCountiesByEmployeeNumber: builder.query({
            query: (arg: any) => {
                const { employeeNumber } = arg;
                return {
                    url: constants.COUNTIES_BY_EMPLOYEE_NUMBER,
                    params: { employeeNumber },
                };
            },
        }),
    }),
});

export const {
    useGetAllCountriesQuery,
    useGetCaCategoriesQuery,
    useGetCaRolesQuery,
    useGetCaTemplateQuery,
    useGetCaApprovalOptionsQuery,
    useGetCaApproverRolesQuery,
    useInsertCreateActionTemplateMutation,
    useInsertCaApprovalQueuesMutation,
    useGetCaApprovalQueuesByTemplateIdQuery,
    useGetCaHistoryQuery,
    useGetCaApprovalStatusHistoryQuery,
    useGetCaRecordsQuery,
    useGetGlLocationsQuery,
    useGetParentClientsQuery,
    useGetProgramsQuery,
    useGetCountiesByEmployeeNumberQuery,
} = correctiveActionsSlice;

